import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@/app/routes";
const changedAccountNos = new Set<string>();

export function markAddressChanged(accountNo: string): void {
  changedAccountNos.add(accountNo);
}
export function useAddressChangeGuard(accountNo: string | undefined): boolean {
  const navigate = useNavigate();
  const [alreadyChanged] = useState(
    () => accountNo !== undefined && changedAccountNos.has(accountNo),
  );

  useEffect(() => {
    if (!alreadyChanged) {
      return;
    }
    void navigate(ROUTES.settings.accountDocumentAddress, { replace: true });
  }, []);

  return alreadyChanged;
}
